import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TranslationService {
  slectedlang: any = 'EN'
  public localizationSubject: BehaviorSubject<string> = new BehaviorSubject<string>('EN')
  public localization$: Observable <string> = this.localizationSubject.asObservable()
  constructor(private translate: TranslateService) {
    this.translate.setDefaultLang('en');
  }

  setLanguage(lang: string): void {
    this.translate.use(lang);
    if(lang  === 'en'){
      this.slectedlang = 'EN'
    }
    else{
      this.slectedlang = 'عربی'
    }
    this.localization = this.slectedlang
  }

  getSelectedLanguage(){
    return this.translate.currentLang
  }

  get localization():string {
    return this.localizationSubject.value
  }

  set localization(value:string){
    this.localizationSubject.next(value)
  }
}